import { Trophy } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import {
  type ExecMonthlyRow,
  formatMetric,
  METRIC_CONFIG,
  METRIC_ORDER,
  type RecordMetricKey,
  type YoyDeltas,
} from "./types";
import { YoyDelta } from "./yoy-delta";

interface KpiCardGridProps {
  currentRow: ExecMonthlyRow;
  yoy: YoyDeltas;
  recordKeys: RecordMetricKey[];
}

export function KpiCardGrid({ currentRow, yoy, recordKeys }: KpiCardGridProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {METRIC_ORDER.map((key) => {
        const config = METRIC_CONFIG[key];
        const isRecord = recordKeys.includes(key as RecordMetricKey);
        return (
          <Card key={key} className="relative overflow-hidden">
            {isRecord && (
              <div className="absolute right-3 top-3 flex h-6 w-6 items-center justify-center rounded-full bg-brand-gold/20 text-brand-gold">
                <Trophy className="h-3.5 w-3.5" />
              </div>
            )}
            <CardContent className="pt-6">
              <div className="text-[10px] tracking-widest uppercase text-muted-foreground">
                {config.label}
              </div>
              <div className="mt-2 font-serif text-3xl text-foreground tabular-nums">
                {formatMetric(currentRow[key], config.format)}
              </div>
              <div className="mt-2 flex items-center gap-1 text-xs">
                <YoyDelta delta={yoy[key]} />
                <span className="text-muted-foreground">vs prior year</span>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
